import { TransactionStatesEnum } from '@app/core/enums/transaction-states.enum';
import { Transaction } from '@app/transactions/transaction';

export class TransactionInfoLink {
    public stateEnum: typeof TransactionStatesEnum = TransactionStatesEnum;

    public getLink(transaction: Transaction, newTransactionRedirect: boolean = false): Array<any> {
        return [
            {
                label: 'Pedido',
                url: newTransactionRedirect ? './new-instructions' : './instructions',
                key: 'instructions',
                disabled: false
            },
            {
                label: 'Mensajes',
                url: './states',
                key: 'states',
                disabled: false
            },
            {
                label: 'Comprobantes',
                url: './screenshot',
                key: 'screenshot',
                disabled:
                    transaction.attributes.state < this.stateEnum.TO_FUTURE ||
                    transaction.attributes.state === this.stateEnum.VALIDATION_REQUIRED
            },
            {
                label: 'Factura',
                url: './invoice',
                key: 'invoice',
                disabled:
                    transaction.attributes.state !== this.stateEnum.CREDITED_PAYMENT && transaction.attributes.state !== this.stateEnum.SENT
            }
        ];
    }
}
